import { ApiService } from '../../core/services/api/api.service.js';
import { ExperimentService } from './experiment.service.js';
import { DebugService } from './debug.service.js';
import { REFI_ESIGN_CONST } from '../../../constants/app.constants.js';

export class _FeatureToggleService {
  constructor() {
    this.debug = new DebugService('FeatureToggleService');
    this.featureToggleComplete = false;
    this._featureToggles = [];
  }

  setFeatureToggles(featureToggles) {
    this._featureToggles = featureToggles;
    ApiService.setGen3Routing(this.isEnabled('bff-postapp-routing-esign'));
  }

  async getFeatureToggleStatus(featureKey) {
    const url = REFI_ESIGN_CONST.GET_FEATURE_TOGGLE_URL(featureKey);
    let featureStatus = [this._featureToggles.find(feature => feature.featureKey === featureKey) || false];
    try {
      if (!featureStatus[0]) {
        featureStatus = await ApiService.get(url);
      }
      this.updateStratumExperiments(featureStatus);
      return featureStatus[0].isEnabled;
    } catch (error) {
      this.debug.log('error getting feature toggle status', error);
    }
    return featureStatus[0];
  }

  async getMultipleFeatureToggleStatus(featureKeys) {
    let url = REFI_ESIGN_CONST.GET_FEATURE_TOGGLE_URL('~');
    url = `${url}?featureKeys=${featureKeys}`;
    const toggleArray = this._featureToggles.map(toggles => toggles.featureKey);

    try {
      // loop through the feature toggle object list. if all the feature keys are found in the list, set the list to featureList. If not, make the api call
      const featureList = featureKeys.split(',').every(feature => toggleArray.includes(feature)) ? this._featureToggles : await ApiService.get(url);
      this.updateStratumExperiments(featureList);
      return featureList;
    } catch (error) {
      this.debug.log('error getting feature toggle status', error);
    }
    return null;
  }

  isEnabled(featureKey) {
    return this._featureToggles.find(f => f.featureKey === featureKey)?.isEnabled ?? false;
  }

  updateStratumExperiments(arrayOfFeatureObjects) {
    const newlyAddedFeatures = [];
    const removedFeatures = [];
    arrayOfFeatureObjects.forEach(featureObj => {
      newlyAddedFeatures.push(featureObj.featureKey + (featureObj.isEnabled ? '-test' : '-bau'));
      removedFeatures.push(featureObj.featureKey + (featureObj.isEnabled ? '-bau' : '-test'));
    });
    ExperimentService.updateExperiments(newlyAddedFeatures, removedFeatures);
  }
}

export const FeatureToggleService = new _FeatureToggleService();
